import { 
    Pool_OptionRenderer 
} from "./Pool_OptionRenderer.js";

import { 
    formatWallHeight, 
    calculateStartingPrice, 
    sortOptions, 
    renderExtraInfo, 
    isVariantAvailable,
    handleSelection
} from "./Pool_Utils.js";

class Pool_Style {
    /**
     * Creates an instance of the Pool_Style class.
     * @param {Array} poolStyles - Available pool styles.
     * @param {Object} configurator - Reference to the main PoolConfigurator instance.
     */
    constructor(poolStyles, configurator) {
        this.poolStyles = poolStyles;
        this.configurator = configurator;
        this.container = document.getElementById("step-1-options");
    }

    /**
     * Renders available pool styles based on stock and compatibility.
     */
    render() {
        const skimmerPrice = parseFloat(this.configurator.state.selectedSkimmer?.price || 0);

        // Generate pool style options with computed details
        const options = this.poolStyles.map(style => {
            const hasPoolVariants = isVariantAvailable(style.variants);
            const compatibleTypes = style.compatibleLinerTypes || [];
            const poolHeight = formatWallHeight(style.height);

            const startingPrice = hasPoolVariants 
                ? calculateStartingPrice(style.variants, this.configurator.steps.liner.linerStyles, compatibleTypes, poolHeight, skimmerPrice)
                : null;

            return {
                id: style.id || `ID_${Math.random()}`,
                name: style.name,
                image: style.image,
                compatibleLinerTypes: compatibleTypes,
                startingPrice,
                stock: hasPoolVariants && startingPrice !== null ? 1 : 0,
                height: poolHeight,
                material: style.material || "Unknown",
                variants: [...style.variants]
            };
        });

        this.container.innerHTML = Pool_OptionRenderer.renderOptions(
            sortOptions(options),
            "Choose Your Pool Style",
            (selectedItem) => handleSelection(this.configurator, "pool-style", selectedItem),
            renderExtraInfo,
            "pool-style"
        );
    }
}

export { Pool_Style };
